export enum CargoTempLogOxygenUnitEnum {
    PerCent = '%',
    PerMillion = 'ppm'
}
